
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.013 11.252c.074.34.113.689.113 1.045 0 3.445-3.644 6.25-8.125 6.25a10.15 10.15 0 01-3.062-.473l-.887-.281-.762.539a8.396 8.396 0 01-2.246 1.133 9.795 9.795 0 00.778-1.57l.414-1.098-.805-.852c-.707-.754-1.555-2-1.555-3.648 0-3.445 3.645-6.25 8.125-6.25 1 0 1.96.14 2.845.395a4.65 4.65 0 01.438-1.822A12.092 12.092 0 0013 4.172c-5.523 0-10 3.637-10 8.125 0 1.86.778 3.562 2.067 4.933-.582 1.54-1.793 2.844-1.813 2.86a.937.937 0 00.684 1.582c2.402 0 4.297-1.004 5.433-1.809 1.13.356 2.348.559 3.63.559 5.523 0 10-3.637 10-8.125 0-.553-.069-1.094-.198-1.616a4.645 4.645 0 01-1.791.571z","fill":"#000"}}),_c('path',{attrs:{"d":"M20.434 10.02a3.5 3.5 0 100-7 3.5 3.5 0 000 7z","fill":"#FF4954","color":"#ff4954"}})])
          )
        }
      }
    